import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Scroll-reveal wrapper
export function Reveal({ children, className, delay = 0, y = 28, as = "div", ...props }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </M>
  );
}

// Section eyebrow label
export function Eyebrow({ children, dark = false, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] uppercase",
        dark ? "text-re-crimson" : "text-re-red",
        className
      )}
      data-testid="eyebrow"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-gradient-red" />
      {children}
    </span>
  );
}

// Primary red gradient button
export function GradientButton({ children, className, testid, ...props }) {
  return (
    <motion.button
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.97 }}
      data-testid={testid}
      className={cn(
        "group relative inline-flex items-center justify-center gap-2 rounded-full bg-gradient-red px-7 py-3.5 text-sm font-semibold text-white shadow-[0_10px_30px_-8px_rgba(240,24,45,0.6)] transition-shadow hover:shadow-[0_18px_44px_-10px_rgba(240,24,45,0.75)]",
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
}

// Secondary / ghost button
export function GhostButton({ children, className, dark = false, testid, ...props }) {
  return (
    <motion.button
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.97 }}
      data-testid={testid}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full border px-7 py-3.5 text-sm font-semibold transition-colors",
        dark
          ? "border-white/20 text-white hover:border-white/40 hover:bg-white/5"
          : "border-re-line text-re-ink hover:border-re-ink/40 hover:bg-re-soft",
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
}
